// extracted by mini-css-extract-plugin
export default {"SliderInput":"QuestionSlider_SliderInput__0O07L","SliderContainer":"QuestionSlider_SliderContainer__vh5RA"};